<section
  class="kuba-subnav"
  [attr.aria-label]="label() | translate"
  (keydown)="onKeydown($event)"
>
  <header class="kuba-subnav-header">
    <span
      class="kuba-subnav-icon icon ic-md icon-{{ feature().key | lowercase }}"
      aria-hidden="true"
    ></span>
    <span class="kuba-subnav-title">{{ label() | translate }}</span>
    <a
      class="kuba-subnav-open"
      [routerLink]="urlBase() + '/' + feature().linkText"
      [attr.aria-label]="('SUB_NAVIGATION.OPEN' | translate) + ' ' + (label() | translate)"
      (click)="navigated.emit()"
      >{{ "SUB_NAVIGATION.OPEN" | translate }}</a
    >
  </header>
  @if (state().caption) {
    <p class="kuba-subnav-caption">{{ state().caption }}</p>
  }
  @if (state().loading) {
    <p class="kuba-subnav-state" role="status">{{ "SUB_NAVIGATION.LOADING" | translate }}</p>
  } @else if (state().rows.length === 0) {
    <p class="kuba-subnav-state">{{ emptyKey() | translate }}</p>
  } @else {
    @if (searchable()) {
      <div class="kuba-subnav-search">
        <i class="pi pi-search" aria-hidden="true"></i>
        <input
          pInputText
          type="search"
          autocomplete="off"
          [attr.aria-label]="'SEARCH' | translate"
          [placeholder]="'SEARCH' | translate"
          [value]="query()"
          (input)="query.set($any($event.target).value)"
        />
      </div>
    }
    <ul class="kuba-subnav-list">
      @for (row of visibleRows(); track row.key) {
        <li>
          <a
            class="kuba-subnav-row"
            [routerLink]="row.commands"
            [queryParams]="row.queryParams"
            routerLinkActive="is-current"
            ariaCurrentWhenActive="page"
            (click)="navigated.emit()"
          >
            @if (row.icon) {
              <i class="pi {{ row.icon }} kuba-subnav-row-icon" aria-hidden="true"></i>
            }
            <span>{{ row.translate ? (row.label | translate) : row.label }}</span>
          </a>
        </li>
      } @empty {
        <li class="kuba-subnav-state">{{ "NO_RECORDS_FOUND" | translate }}</li>
      }
    </ul>
  }
</section>
